import { withStyles } from '@material-ui/core';
import styles from './SimpleProgressBar.styles';
import SimpleProgressBar from './SimpleProgressBar';

export default withStyles(styles)(SimpleProgressBar);
